import { Vue, Component, Prop } from "vue-property-decorator";
import MealCard from "@/components/mealCard/mealCard";
import { Getter, Mutation } from "vuex-class";

// External components
import HorizontalScrollCarousel from "../basicComponents/horizontalScrollCarousel/horizontalScrollCarousel";

@Component({
  components: {
    MealCard,
    HorizontalScrollCarousel,
  },
})
export default class MealsCarousel extends Vue {
  @Prop({ default: null }) detailMenu;
  @Prop({ default: true }) isEditButtonEnabled: boolean;
  @Prop({ default: null }) actionLabel;
  @Prop({ default: "$Title" }) carouselTitle;
  @Prop({ default: true }) showEmptyMeals;

  @Getter getIsUnderMobile;

  @Mutation SET_DISH_TO_REPLACE;

  get getSortedDays() {
    // Return plates sorted by count_id (ascending)
    return this.detailMenu.day.sort((a, b) => {
      return a.count_id - b.count_id;
    });
  }

  changeDish(dishObjectInfo: any) {
    const { menu_id, count_id } = dishObjectInfo;
    this.SET_DISH_TO_REPLACE(dishObjectInfo);
    this.$router.push({ name: "chefSuggestions", params: { menu_id, count_id } });
  }
}
